import { api } from '../../functions/api';
import { ApiPath } from '../../api/ApiPath';

export function assignAssets(
  assetIds: number[],
  customerId: number | null = null,
  sourceSiteId: string | null = null,
  destinationSiteId: string | null = null,
): Promise<void> {
  return api({
    url: ApiPath.DashboardTransactions,
    method: 'post',
    data: {
      assetIds,
      customerId,
      sourceSiteId,
      destinationSiteId,
    },
  });
}
